export class SearchResult {
  type: string;
  text: string;

  constructor(data?: { type: string; text: string }) {
    this.type = data?.type || '';
    this.text = data?.text || '';
  }
}
